// @flow
import React from 'react';
import LazyLoad from 'components/fragments/LazyLoad';
import BackgroundImage from 'components/fragments/BackgroundImage';

export type StateProps = {
  bloc_entreprise: {
    object_id: number,
    type_name: string,
    title: string,
    description: string,
    texte_cta: string,
    featured_image: string,
    featured_media: Object,
    slug_complet: string,
  }
};

const HubEntreprise = (props: StateProps) => { 
  return (
    props.bloc_entreprise.object_id > 0 &&
      <LazyLoad>
        <section className="section section--bg">
          <div className="container">
            <div className="row">
              <div className="col col-md-9 col-lg-6">
                <h2 className="mb-2">{props.bloc_entreprise.title}</h2>
                <p className="ft-secondary ft-white-secondary mb-3 mb-md-4">{props.bloc_entreprise.description}</p>
                <a href={props.bloc_entreprise.slug_complet} className="btn btn--cheer">
                  <i className="icon icon-chevron-right link-icon is-dark is-inline"></i>
                  <span>{props.bloc_entreprise.texte_cta}</span>
                </a>
              </div>
            </div>
          </div>
          <BackgroundImage
              className="img-bg img-blue-dark"
              illustration={props.bloc_entreprise.featured_media && props.bloc_entreprise.featured_media.src}
              srcset={props.bloc_entreprise.featured_media && props.bloc_entreprise.featured_media.sizes}
              forceState={'large'}
          />
        </section>
      </LazyLoad>
  );
};

export default HubEntreprise;
